import { Injectable } from '@angular/core'
import { AwsRum, AwsRumConfig } from 'aws-rum-web'
import { environment } from '../../../../environments/environment'
import { version as appVersion } from '../../../../../package.json'
import { SessionStorageKeys } from '../../auth/models/auth.model'

@Injectable({
  providedIn: 'root'
})
export class AwsRumService {
  private awsRum: AwsRum | null = null

  constructor() {}

  initAwsRum(): void {
    if (!environment.awsRum.enabled) {
      return
    }

    try {
      const config: AwsRumConfig = {
        sessionSampleRate: 1,
        identityPoolId: environment.awsRum.identityPoolId,
        endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
        telemetries: ['performance', 'errors', 'http'],
        allowCookies: true,
        enableXRay: false,
        signing: true
      }

      const APPLICATION_ID: string = environment.awsRum.applicationId
      const APPLICATION_VERSION: string = appVersion
      const APPLICATION_REGION: string = 'us-east-1'

      this.awsRum = new AwsRum(
        APPLICATION_ID,
        APPLICATION_VERSION,
        APPLICATION_REGION,
        config
      )

      console.log('✅ AWS RUM inicializado com sucesso')
    } catch (error) {
      console.error('❌ Erro ao inicializar AWS RUM:', error)
    }
  }

  logError(error: Error): void {
    if (!this.awsRum || typeof this.awsRum.recordError !== 'function') {
      return
    }

    try {
      const userInfo = this.getUserInfo()

      const enrichedError = new Error(error.message)
      enrichedError.name = error.name
      enrichedError.stack = error.stack

      Object.assign(enrichedError, {
        userInfo,
        originalError: error
      })

      this.awsRum.recordError(enrichedError)
    } catch (captureError) {
      console.error('Erro ao enriquecer o erro para AWS RUM:', captureError)
      this.awsRum.recordError(error)
    }
  }

  private getUserInfo(): Record<string, any> {
    try {
      const userProfileStr = sessionStorage.getItem(
        SessionStorageKeys.UserProfile
      )
      const loggedUserStr = sessionStorage.getItem(
        SessionStorageKeys.LoggedUser
      )

      let userProfile = null
      let loggedUser = null

      if (userProfileStr) {
        const parsed = JSON.parse(userProfileStr)
        if (parsed && parsed.loggedProfile) {
          const { id, email, firstName, lastName, types, status, city } =
            parsed.loggedProfile
          userProfile = {
            id,
            email,
            firstName,
            lastName,
            types,
            status,
            city: city?.name
          }
        }
      }

      if (loggedUserStr) {
        const parsed = JSON.parse(loggedUserStr)
        if (parsed) {
          const { id, firstName, lastName, nickname } = parsed
          loggedUser = { id, firstName, lastName, nickname }
        }
      }

      return {
        profile: userProfile,
        user: loggedUser,
        isLoggedIn: !!userProfile || !!loggedUser
      }
    } catch (error) {
      return { error: 'Erro ao obter informações do usuário' }
    }
  }
}
